module.exports = __webpack_public_path__ + "img/ar_hash_down.a1fd5bd9.svg";